/** Keep the selected appearance in sync across routes and the account record.
 * The previous implementation toggled local state but separately inverted the
 * database's *previous* value. Those values can differ, causing apparent resets.
 */
const pendingByUsername = new Map();

export function switchPlatformTheme({ that, authenticatedPut, currentUser }) {
  const previous = that.state.mode_light_dark === 'light' ? 'light' : 'dark';
  const next = previous === 'dark' ? 'light' : 'dark';

  that.setState({ mode_light_dark: next });
  try { localStorage.setItem('mode_light_dark', next); }
  catch (error) { console.warn('Unable to save the appearance preference locally.'); }

  const username = String(that.state.currentUser || currentUser || '').trim().toLowerCase();
  if (!username || typeof authenticatedPut !== 'function') return;

  // Serialize rapid toggles, so an older asynchronous request cannot overwrite
  // a newer choice on the same page. Other routes read the saved browser value.
  const prior = pendingByUsername.get(username) || Promise.resolve();
  const save = prior.catch(() => {}).then(() => authenticatedPut('api1169ba1e', '', {
    body: {
      category: 'db', tableName: 'users', primaryKey: username,
      requestOperation: 'update', updateExpression: 'SET appearanceMode = :appearanceMode',
      expressionAttributeValues: { ':appearanceMode': next }
    }
  }));
  pendingByUsername.set(username, save);
  save.catch(() => {
    console.warn('Appearance updated locally, but account preference sync failed.');
  }).finally(() => {
    if (pendingByUsername.get(username) === save) pendingByUsername.delete(username);
  });
}
